import React from 'react';
import { Link } from 'react-router-dom';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const RFQStatusCard = ({ rfq }) => {
  const getStatusColor = (status) => {
    switch (status?.toLowerCase()) {
      case 'approved': case'completed':
        return 'text-success bg-success/10';
      case 'pending': case'under review':
        return 'text-warning bg-warning/10';
      case 'quoted':
        return 'text-primary bg-primary/10';
      case 'rejected':
        return 'text-error bg-error/10';
      default:
        return 'text-muted-foreground bg-muted';
    }
  };

  const getStatusIcon = (status) => {
    switch (status?.toLowerCase()) {
      case 'approved': case'completed':
        return 'CheckCircle';
      case 'pending': case'under review':
        return 'Clock';
      case 'quoted':
        return 'FileText';
      case 'rejected':
        return 'XCircle';
      default:
        return 'AlertCircle';
    }
  };

  const formatDate = (date) => {
    return new Date(date)?.toLocaleDateString('en-GB', {
      day: '2-digit',
      month: 'short',
      year: 'numeric'
    });
  };

  return (
    <div className="bg-card border border-border rounded-lg p-4 hover:shadow-moderate transition-smooth">
      <div className="flex items-start justify-between mb-3">
        <div className="flex-1">
          <div className="flex items-center space-x-2 mb-2">
            <h4 className="font-semibold text-foreground">RFQ #{rfq?.id}</h4>
            <span className={`inline-flex items-center px-2 py-1 rounded-full text-xs font-medium ${getStatusColor(rfq?.status)}`}>
              <Icon name={getStatusIcon(rfq?.status)} size={12} className="mr-1" />
              {rfq?.status}
            </span>
          </div>
          <p className="text-sm text-muted-foreground mb-2">{rfq?.title}</p>
          <div className="flex items-center space-x-4 text-xs text-muted-foreground">
            <span>Submitted: {formatDate(rfq?.submittedDate)}</span>
            {rfq?.responseDate && (
              <span>Response: {formatDate(rfq?.responseDate)}</span>
            )}
          </div>
        </div>
        
        <div className="flex flex-col space-y-2">
          <Link to={`/rfq-management?rfq=${rfq?.id}`}>
            <Button variant="outline" size="sm" iconName="Eye">
              View
            </Button>
          </Link>
          {rfq?.status?.toLowerCase() === 'quoted' && (
            <Button variant="default" size="sm" iconName="ShoppingCart">
              Order
            </Button>
          )}
        </div>
      </div>
      {rfq?.estimatedValue && (
        <div className="pt-3 border-t border-border">
          <div className="flex items-center justify-between text-sm">
            <span className="text-muted-foreground">Estimated Value:</span>
            <span className="font-semibold text-foreground">UGX {rfq?.estimatedValue?.toLocaleString()}</span>
          </div>
        </div>
      )}
    </div>
  );
};

export default RFQStatusCard;